import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

interface RetryConfirmationDialogProps {
  open: boolean;
  orgName: string;
  count: number;
  failureType: string;
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation for restarting (as new) the failed ATC runs matching a specific
 * error message for a single org. Shows the exact count before running.
 */
export const RetryConfirmationDialog: React.FC<
  RetryConfirmationDialogProps
> = ({ open, orgName, count, failureType, isPending, onConfirm, onCancel }) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onCancel();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Retry failures as new</DialogTitle>
          <DialogDescription>
            This restarts{' '}
            <span className="font-semibold text-foreground">{count}</span>{' '}
            failed ATC run{count === 1 ? '' : 's'} for{' '}
            <span className="font-semibold text-foreground">{orgName}</span> as
            brand-new invocations. The original failed runs are left in place.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md bg-gray-50 border p-2">
          <p className="text-xs font-mono text-gray-600 break-words">
            {failureType}
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Restarting...' : `Restart ${count} as new`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
